import { useMemo } from "react"
import PropTypes from "prop-types"
import { get, isNil } from "lodash"
import { TableRow, TableCell } from "@mui/material"
import { numberFormatter } from "helpers/formatters/numbers"
import { computeContributorFormatter } from "helpers/contributors"

function ContributorsGroupDetailsRow({
  showGroup,
  group,
  selected,
  noPercent,
  hideSelectedField,
  formatter,
}) {
  const valueCell = useMemo(() => {
    if (hideSelectedField) return null
    const value = get(group, selected.field)
    return (
      <TableCell align="right">
        {isNil(value) ? "-" : computeContributorFormatter({ formatter, noPercent })(value)}
      </TableCell>
    )
  }, [group, selected, noPercent, hideSelectedField, formatter])

  return (
    <TableRow className="detail-row">
      <TableCell className="group-name" title={group.name} component="th" scope="row">
        <div className="factor-link-wrapper">
          <a className="factor-link" onClick={() => showGroup(group)}>
            <div className="display-name">{group.name}</div>
          </a>
        </div>
      </TableCell>
      <TableCell colSpan={hideSelectedField ? 2 : 1} align="right">
        {numberFormatter(group.totalPercentEquity * 100)}
      </TableCell>
      {valueCell}
    </TableRow>
  )
}

ContributorsGroupDetailsRow.propTypes = {
  showGroup: PropTypes.func.isRequired,
  group: PropTypes.object.isRequired,
  selected: PropTypes.object.isRequired,
  noPercent: PropTypes.bool,
  hideSelectedField: PropTypes.bool,
  formatter: PropTypes.func,
}

export default ContributorsGroupDetailsRow
